import type { RefObject } from 'react';
import { useState, useEffect } from 'react';

interface UseScrollVisibilityReturn {
  showLeftControl: boolean;
  showRightControl: boolean;
  updateControlsVisibility: () => void;
}

export const useScrollVisibility = (
  containerRef: RefObject<HTMLElement>,
  threshold = 60,
): UseScrollVisibilityReturn => {
  const [showLeftControl, setShowLeftControl] = useState(false);
  const [showRightControl, setShowRightControl] = useState(true);

  const updateControlsVisibility = () => {
    if (containerRef.current) {
      const { scrollLeft, scrollWidth, clientWidth } = containerRef.current;
      setShowLeftControl(scrollLeft > threshold);
      setShowRightControl(scrollLeft < scrollWidth - clientWidth - threshold);
    }
  };

  useEffect(() => {
    if (containerRef.current) {
      containerRef.current.addEventListener('scroll', updateControlsVisibility);
      updateControlsVisibility();
    }

    return () => {
      if (containerRef.current) {
        containerRef.current.removeEventListener('scroll', updateControlsVisibility);
      }
    };
  }, [threshold]);

  return { showLeftControl, showRightControl, updateControlsVisibility };
};
